import { render, staticRenderFns } from "./DomainPixel.vue?vue&type=template&id=166fb282&scoped=true"
import script from "./DomainPixel.vue?vue&type=script&lang=js"
export * from "./DomainPixel.vue?vue&type=script&lang=js"
import style0 from "./DomainPixel.vue?vue&type=style&index=0&id=166fb282&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "166fb282",
  null
  
)

export default component.exports